/**
 * @fileoverview POST handler for the "/app_settings/:app_group_id/message_prioritization/rules/validation" endpoint
 */
import fetch from "@lib/fetch";

import { transformProps } from "../appSettingsAppGroupIdMessagePrioritizationRules/transform";
import type { PostMessagePrioritizationRulesProps } from "../appSettingsAppGroupIdMessagePrioritizationRules";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationRulesValidationCacheKeys } from "./constants";
import type { MessagePrioritizationRulesValidationResult } from "./types";

export const postMessagePrioritizationRulesValidation = reactQueryMutationAdapter(
  appSettingsAppGroupIdMessagePrioritizationRulesValidationCacheKeys,
  (props: PostMessagePrioritizationRulesProps): Promise<MessagePrioritizationRulesValidationResult> => {
    const body = transformProps(props);
    return fetch(
      `/app_settings/${props.appGroupId}/message_prioritization/rules/validation`,
      "POST",
      body,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
